import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Home-Page" }
const _hoisted_2 = { class: "max-w-7xl mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_cursor = _resolveComponent("app-cursor")!
  const _component_app_scrollprogress = _resolveComponent("app-scrollprogress")!
  const _component_app_name_banner = _resolveComponent("app-name-banner")!
  const _component_app_menu = _resolveComponent("app-menu")!
  const _component_AppIntroToName = _resolveComponent("AppIntroToName")!
  const _component_AppSkills = _resolveComponent("AppSkills")!
  const _component_AppTools = _resolveComponent("AppTools")!
  const _component_app_footer = _resolveComponent("app-footer")!
  const _component_app_leftnav = _resolveComponent("app-leftnav")!
  const _component_app_rightnav = _resolveComponent("app-rightnav")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_app_cursor),
    _createVNode(_component_app_scrollprogress),
    _createVNode(_component_app_name_banner),
    _createElementVNode("header", null, [
      _createVNode(_component_app_menu)
    ]),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_AppIntroToName, { id: "Home" }),
      _createVNode(_component_AppSkills, { id: "Skills" }),
      _createVNode(_component_AppTools, { id: "Tools" })
    ]),
    _createElementVNode("footer", null, [
      _createVNode(_component_app_footer)
    ]),
    _createVNode(_component_app_leftnav),
    _createVNode(_component_app_rightnav)
  ]))
}